module.exports = __webpack_public_path__ + "img/search-icon.81098bce.svg";